import { formatDuration, intervalToDuration, parse } from 'date-fns';

export const getApplyParamters = (cookies, queryParams) => {
  const first_visit_date = `first_visit_date=${cookies['first_visit_date']}`;
  const first_landing_page = `first_landing_page=${cookies['first_landing_page']}`;
  const first_touch_paramaters = `first_touch_paramaters=${cookies['first_touch_paramaters']}`;
  const last_touch_paramaters = `last_touch_paramaters=${cookies['last_touch_paramaters']}`;

  return encodeURIComponent(
    `${queryParams}&${first_visit_date}&${first_landing_page}&${first_touch_paramaters}&${last_touch_paramaters}`
  );
};

export const getParamterValue = (url, key) => {
  const urlParams = new URL(url);
  return urlParams.searchParams.get(key) ?? '';
};

export const getConversionLag = (first_touch_date) => {
  if (!first_touch_date) return '0 seconds';

  let date =
    typeof first_touch_date === 'string' && !first_touch_date.includes('T')
      ? parse(first_touch_date, 'dd/MM/yyyy', new Date())
      : new Date(first_touch_date);

  if (isNaN(date.getTime())) {
    date = parse(first_touch_date, 'MM/dd/yyyy', new Date());
  }

  const duration = intervalToDuration({
    start: date,
    end: new Date()
  });

  return formatDuration(duration);
};
